module.exports = __webpack_public_path__ + "img/banner5.48f277b0.png";